import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppStore } from '@/store';
import { initGA, trackPageView } from '@/lib/ga';

export default function RouteAnalyticsTracker() {
  const location = useLocation();
  const { allowAnalytics } = useAppStore();

  useEffect(() => {
    if (!allowAnalytics) {
      return;
    }

    initGA();
    trackPageView(location.pathname + location.search);
  }, [allowAnalytics, location.pathname, location.search]);

  return null;
}
